import { useContext } from "react";
import LoginContext from "../context/LoginProvider";

const useTrackWebContext = () => {
    return useContext(LoginContext)
}

export default useTrackWebContext;